import { SQLIndex } from '../../fms.core/constants';
import {TextValue} from '../../framework.core/data/TextValue';

export class CheckLookup  {
    textValue: TextValue | null = null;
    labelName: string = '';
    sqlIndex: SQLIndex = SQLIndex.Unknown;

    constructor(init?:Partial<CheckLookup>) {
        Object.assign(this, init);
      }
}
